import React from 'react';
import './UIPageTitle.scss';

export interface UIPageTitleProps {
  /**
   * Основний заголовок сторінки
   */
  title: string;

  /**
   * Елемент дії справа (кнопка, група кнопок, тощо)
   */
  action?: React.ReactNode;

  /**
   * Показувати розділювач під заголовком
   */
  showDivider?: boolean;

  /**
   * Розмір заголовка
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * Варіант кольору заголовка
   */
  variant?: 'default' | 'primary' | 'secondary';

  /**
   * Центрувати заголовок (автоматично, коли немає action)
   */
  center?: boolean;

  /**
   * Компактний варіант (менший gap)
   */
  compact?: boolean;

  /**
   * Зробити заголовок липким (sticky)
   */
  sticky?: boolean;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * HTML тег для заголовка (семантика)
   */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

// Моковые данные для демонстрації
const mockProps: UIPageTitleProps = {
  title: 'Account',
  action: undefined, // Буде показана мокова кнопка
  showDivider: true,
  size: 'medium',
  variant: 'default',
  center: false,
  compact: false,
  sticky: false,
  as: 'h1',
};

const baseClass = 'UIPageTitle';

const UIPageTitle: React.FC<UIPageTitleProps> = ({
                                                   title = mockProps.title,
                                                   action,
                                                   showDivider = mockProps.showDivider,
                                                   size = mockProps.size,
                                                   variant = mockProps.variant,
                                                   center,
                                                   compact = mockProps.compact,
                                                   sticky = mockProps.sticky,
                                                   className = '',
                                                   as = mockProps.as,
                                                 }) => {
  // Автоматично центруємо, якщо немає action і не задано явно
  const shouldCenter = center || (!action && center !== false);

  const titleClasses = [
    baseClass,
    `${baseClass}--${size}`,
    variant !== 'default' && `${baseClass}--${variant}`,
    shouldCenter && `${baseClass}--center`,
    compact && `${baseClass}--compact`,
    sticky && `${baseClass}--sticky`,
    !showDivider && `${baseClass}--no-divider`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Динамічний тег для заголовка
  const TitleTag = as as keyof JSX.IntrinsicElements;

  // Мокова кнопка для демонстрації (коли немає action)
  const mockAction = !action ? (
    <button
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '14px 20px',
        gap: '10px',
        background: '#105E96',
        borderRadius: '8px',
        border: 'none',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '14px',
        letterSpacing: '-0.03em',
        color: '#FFFFFF',
        cursor: 'pointer',
      }}
    >
      My profile
    </button>
  ) : null;

  return (
    <div className={titleClasses}>
      <div className={`${baseClass}__content`}>
        <TitleTag className={`${baseClass}__title`}>{title}</TitleTag>

        {(action || mockAction) && (
          <div className={`${baseClass}__action`}>{action || mockAction}</div>
        )}
      </div>

      {showDivider && <hr className={`${baseClass}__divider`} />}
    </div>
  );
};

export default UIPageTitle;